import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import type {
  LC_GetSecurityGroupsByPermissionOut,
  SecurityGroupOption,
} from '../types/securityGroupsByPermission.types';
import { mapSecurityGroupsByPermission } from '../mappers/securityGroupsByPermission.mapper';


export class SecurityGroupsByPermissionService {
  async getByPermission(): Promise<ApiResponse<SecurityGroupOption[]>> {
    const endpoint = API_CONFIG.ENDPOINTS.SECURITY_GROUPS.BY_PERMISSION;

    const response = await apiClient.get<LC_GetSecurityGroupsByPermissionOut>(endpoint);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapSecurityGroupsByPermission(response.data) };
  }
}

export const securityGroupsByPermissionService = new SecurityGroupsByPermissionService();
